import { render, staticRenderFns } from "./cardDetail.vue?vue&type=template&id=6f00442c&scoped=true"
import script from "./cardDetail.vue?vue&type=script&lang=js"
export * from "./cardDetail.vue?vue&type=script&lang=js"
import style0 from "./cardDetail.vue?vue&type=style&index=0&id=6f00442c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f00442c",
  null
  
)

export default component.exports